import React from 'react';
import PropTypes from 'prop-types';
import Locales from 'locales';
import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';

const ConfirmationModal = ({
  isOpen = false,
  setOpenModal = () => {},
  title = null,
  description = null,
  confirmBtnLabel = Locales.base.button.save,
  confirmBtnVariant = 'hajj',
  message = null,
  onConfirm = () => {},
}) => {
  const handleConfirmAction = () => {
    onConfirm();
    setOpenModal(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setOpenModal}>
      <DialogContent
        overlayClassName="bg-[#13231c66]"
        className="max-h-[90vh] w-[460px] max-w-[calc(100vw-32px)] gap-0 overflow-y-auto rounded-[10px] border-[#dfe6e1] bg-white p-[25px] text-[#27392f] shadow-[0_18px_60px_#132a2522] sm:rounded-[10px]"
      >
        <DialogHeader className="pr-8 text-left">
          <DialogTitle className="text-[20px] font-semibold leading-7">{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription asChild>
          <div className="mt-3 space-y-2 text-sm leading-[22px] text-[#64746a]">
            {description && <p>{description}</p>}
            {message}
          </div>
        </DialogDescription>
        <DialogFooter className="mt-[25px] flex-row flex-wrap justify-end gap-2.5 sm:space-x-0">
          <Button
            variant="outline"
            className="h-[38px] border-[#d5e0d9] px-3 shadow-none"
            onClick={() => setOpenModal(false)}
          >
            {Locales.base.button.cancel}
          </Button>
          <Button
            variant={confirmBtnVariant}
            className="h-[38px] px-3 shadow-none hover:shadow-none"
            onClick={handleConfirmAction}
          >
            {confirmBtnLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  confirmBtnLabel: PropTypes.string,
  confirmBtnVariant: PropTypes.string,
  setOpenModal: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ConfirmationModal;
